import { markUserUpdatedInMock } from './users';
import type { UserUpdate } from '../endpoints/updateUser';

// Mock of the «Editar datos» WRITE: simulate latency, then apply the correction to the shared users
// fixture, so a follow-up searchUsersByPhoneMock returns the corrected hit — matrícula reassigned
// included. Idempotent. No error-injection hook, like its write siblings: error-path component
// tests inject a failing fn directly via DI.
export async function updateUserMock(id: string, changes: UserUpdate): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markUserUpdatedInMock(id, changes);
}
